import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAttorneyDetailsRaw = React.lazy(() => import(/* webpackChunkName: "AdminAttorneyDetails" */ './AttorneyDetails'));
export const AdminAttorneyDetails = () => (React.createElement(Page, { title: "Attorney", description: "Attorney" },
    React.createElement(Main, { sidebar: true },
        React.createElement("div", { className: "container-fluid att-main no-pad-r" },
            React.createElement("div", { className: "no-pad attorney-wrap " },
                React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
                    React.createElement(AdminAttorneyDetailsRaw, null)))))));
